import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Services from 'services';
import { userTimezone } from 'redux/session/selectors';
import {
  selectIsResoucesLoading,
  selectReportingError,
  selectReportingResources,
  setReportTokenAndTypes
} from 'redux/reports';
import { cleanReportsState } from 'redux/reports';
import { ReportPanel } from './components/reportPanel';
import { Loading } from 'carbon-components-react';
import { FullHeaderLeftSideFullPanelLayout } from 'layouts/fullHeader.LeftSideFullPanel.layout';

export const Reports: React.FC<{}> = (props: any) => {
  const dispatch = useDispatch();
  const timezone: string = useSelector(userTimezone);
  const isLoading: boolean = useSelector(selectIsResoucesLoading);
  const resources: any = useSelector(selectReportingResources);
  const reportingError: any = useSelector(selectReportingError);
  // LOCAL STATE
  const [visualizeReady, setVisualizeReady] = useState<boolean>(false);
  const [isReportType, setIsReportType] = useState<boolean>(false);
  // EFFECTS
  useEffect(() => {
    Services.reports.loadVisualizeJS(timezone).then(() => {
      setVisualizeReady(true);
    });
    return () => {
      const ele = document.querySelector('#visualizejs');
      if (ele || ele !== null) {
        const node = ele.parentNode;
        node && node.removeChild(ele);
      }
    };
  }, [timezone]);

  useEffect(() => {
    visualizeReady && dispatch(setReportTokenAndTypes(timezone));
    return () => {
      dispatch(cleanReportsState());
    };
  }, [dispatch, visualizeReady, timezone]);

  useEffect(() => {
    if (!isLoading && resources?.length > 0) {
      setIsReportType(true);
    }
  }, [isLoading, resources]);
  return (
    <div id="reports" className="report" data-testid="reports">
      <FullHeaderLeftSideFullPanelLayout
        pageHeading={'Reporting'}
        pageDescription={
          'Generate and export custom management information reports'
        }
        enableHeaderGlobalBar={true}
      >
        {!isReportType ? (
          reportingError ? (
            <div className="report--wrapper">
              <h6>{reportingError}</h6>
            </div>
          ) : (
            <div className="loader--wrapper">
              <Loading
                description="Active loading indicator"
                withOverlay={false}
              />
            </div>
          )
        ) : (
          <ReportPanel {...props} />
        )}
      </FullHeaderLeftSideFullPanelLayout>
    </div>
  );
};

Reports.displayName = 'ReportsModule';

export default React.memo(Reports);
